import { Assets } from "./assets.ts"

export const Terms = () => {
  return (
    <p className="text-xs text-gray-11 mt-3">
      By signing up, you have read, understood, and agree to the processing of your data and use of
      cookies in accordance with IYK's{" "}
      <a href={Assets.documents.privacyPolicy} target="_blank" className="underline">
        Privacy Policy
      </a>
      {" & "}
      <a href={Assets.documents.termsOfService} target="_blank" className="underline">
        Terms of Service
      </a>
      .
    </p>
  )
}
